import { Input, ViewChild } from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormControlDirective, FormGroup
} from "@angular/forms";
import { UIBaseComponent } from "./ui-base.component";

export class InputBaseComponent extends UIBaseComponent implements ControlValueAccessor {
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  @Input()
  formControl: FormControl;

  @Input()
  formControlName: string;

  @Input()
  formControlGroup: FormGroup;

  @Input() disabled: boolean;

  get control(): AbstractControl {
    return this.formControl || this.formControlGroup.get(this.formControlName);
  }

  constructor() {
    super();
  }

  clearInput(): void {
    this.control.setValue("");
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}
